import React, { useEffect, useRef } from "react";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import moment from "moment";

// const localizer = momentLocalizer(moment);

const CalendarView = ({ data = [] }) => {
  const calenderRef = useRef(null);

  // function renderEventContent(eventInfo) {
  //   return (
  //     <>
  //       <b>{eventInfo.timeText}</b>
  //       <i>{eventInfo.title}</i>
  //     </>
  //   );
  // }

  useEffect(() => {
    try {
      if (calenderRef.current) {
        const eventsList = data
          ?.filter((el) => el?.status === "Approved")
          ?.map((event) => {
            return {
              title: event.holidayName,
              start: moment(event.startDate).toISOString(),
              end: moment(event.endDate).toISOString(),
            };
          });

        const calendar = new Calendar(calenderRef.current, {
          plugins: [dayGridPlugin],
          initialView: "dayGridMonth",
          events: eventsList,
          editable: true,
          selectable: true,
          // eventContent: { renderEventContent },
        });
        calendar.render();
      }
    } catch (error) {
      console.error("Error in CalendarView:", error);
    }
  }, [data]);

  return (
    <div id="calendar-container">
      <div id="calendar" ref={calenderRef}></div>
    </div>
  );
};
export default CalendarView;
